import { Alert } from "reactstrap";
import { PapelEnum } from "services/PerfilService";

// SDD 045 - para quem nao e admin, o menu lateral so aparece com um contrato selecionado
// (Sidebar.js). Sem nenhum contrato disponivel para o papel, a tela ficava vazia e parecia erro.
export function papelSemContrato(state) {
  const user = state?.user
  if (!user?.perfil || user.perfil.idTipo == PapelEnum.ADMIN)
    return false
  return !(user.contratos?.length > 0)
}

// O modal de troca de papel vive no AdminNavbar; este evento deixa o aviso do corpo da pagina abri-lo.
export const EVENTO_TROCAR_PAPEL = 'viatech:trocar-papel'

export default function AvisoSemContrato({ state }) {
  const podeTrocarPapel = (state.user?.papeis?.length || 0) > 1

  const handleTrocarPapel = ev => {
    ev.preventDefault()
    window.dispatchEvent(new Event(EVENTO_TROCAR_PAPEL))
  }

  return (
    <Alert color="warning" className="mb-0">
      <i className="fas fa-exclamation-triangle mr-2" />
      Nenhum contrato disponível para o papel <strong>{state.user?.perfil?.nome}</strong>.
      {' '}As funções que dependem de contrato ficam indisponíveis.
      {' '}Procure o administrador do sistema
      {podeTrocarPapel ? (
        <> ou <a href="trocar_papel" className="alert-link" onClick={handleTrocarPapel}>troque de papel</a>.</>
      ) : '.'}
    </Alert>
  )
}
